import { render } from "./ButtonBar.vue?vue&type=template&id=5bc9b56a&scoped=true"
import script from "./ButtonBar.vue?vue&type=script&lang=js"
export * from "./ButtonBar.vue?vue&type=script&lang=js"

import "./ButtonBar.vue?vue&type=style&index=0&id=5bc9b56a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc9b56a"]])

export default __exports__